function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import Configurable from 'invision-core/src/components/configurable/configurable';
import { UserSecurityContextSelector } from 'invision-core/src/components/session/session.selectors';
import CustomerLocaleKeys from '../../../../../locales/keys';
import { stateGo } from 'redux-ui-router';
import { CurrentCustomerIdSelector, CurrentCustomerSelector } from '../../../../../reducers/selectors/customer.selectors';
import { CustomerAccountStatusViewHasTiles, CustomerAccountStatusViewIsExpandedSelector, CustomerAccountStatusViewModelSelector, CustomerAccountStatusViewNameSelector } from '../../../../../reducers/selectors/customer.account.status.dashboard.selectors';
import { updateOrderStatusFilter } from '../../../../../reducers/actions/order.history.filter.actions';
import { setCaseStatusFilter } from '../../../../../reducers/actions/customer.cases.actions';
import { setTransactionResultFilter } from '../../../../../reducers/actions/customer.transactions.actions';
import { STATE_OR_NAME as ORDER_HISTORY_STATE } from '../../../orderHistory/order.history.config';
import { CASES_LIST_STATE_REDIRECT, E_WALLET_STATE_REDIRECT } from '../../../../../reactRoutes';
import { STATE_OR_NAME as TRANSACTIONS_STATE } from '../../../transactions/transactions.config';
import { customerResetRevokedPassword } from '../../../../../reducers/actions/customer.actions';
import { retrieveCustomerAccountStatus } from '../../../../../reducers/actions/customer.account.status.actions';
import { retrieveCustomTileValue } from '../../../../../reducers/actions/custom.tiles.actions';
var AccountStatusController = /*#__PURE__*/function () {
  function AccountStatusController($ngRedux) {
    _classCallCheck(this, AccountStatusController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys
    });
  }
  return _createClass(AccountStatusController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          caseStatus: MetadataSelectors.codes.MetadataCodeSelector(MetadataConstants.codes.CaseStatus, store),
          caseStatusLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.CaseStatus, store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerAccountStatus: CustomerAccountStatusViewModelSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentUserContext: UserSecurityContextSelector(store),
          hasTilesConfigured: CustomerAccountStatusViewHasTiles(store),
          isExpanded: CustomerAccountStatusViewIsExpandedSelector(store),
          name: CustomerAccountStatusViewNameSelector(store),
          orderStatus: MetadataSelectors.codes.MetadataCodeSelector(MetadataConstants.codes.OrderStatus, store),
          orderStatusLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.OrderStatus, store),
          transactionResults: MetadataSelectors.codes.MetadataCodeSelector(MetadataConstants.codes.TransactionResult, store),
          transactionResultLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.TransactionResult, store)
        };
      };
      var controllerActions = {
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        stateGo: stateGo,
        setCaseStatusFilter: setCaseStatusFilter,
        setTransactionResultFilter: setTransactionResultFilter,
        updateStatusFilter: updateOrderStatusFilter,
        resetRevokedPassword: customerResetRevokedPassword,
        retrieveCustomerAccountStatus: retrieveCustomerAccountStatus,
        retrieveCustomTileValue: retrieveCustomTileValue
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.orderStatusLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.OrderStatus);
      }
      if (!this.state.caseStatusLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.CaseStatus);
      }
      if (!this.state.transactionResultLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.TransactionResult);
      }
      this.actions.retrieveCustomerAccountStatus(this.state.currentCustomerId);
      if (this.state.currentCustomerAccountStatus) {
        this.state.currentCustomerAccountStatus.forEach(function (tile) {
          if (tile.isCustom) {
            _this.actions.retrieveCustomTileValue(tile, _this.state.currentCustomer, _this.state.currentUserContext);
          }
        });
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "handleExpansion",
    value: function handleExpansion() {
      this.state.isExpanded = !this.state.isExpanded;
    }
  }, {
    key: "onActionClick",
    value: function onActionClick(status) {
      var OPEN_CASE_STATUS = '1';
      var NEW_CASE_STATUS = '2';
      var OPEN_ORDER_STATUS = '1';
      var PENDING_ORDER_STATUS = '0';
      switch (status.id) {
        case Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.DEVICE_SESSION_PIN_BOOL:
          this.customerCtrl.openResetDevicePinDialog();
          break;
        case Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.LOGIN_REVOKED_BOOL:
          this.customerCtrl.openResetRevokedPasswordDialog();
          break;
        case Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.OPEN_ORDERS_COUNT:
          this.actions.updateStatusFilter(this.setupFilter(this.state.orderStatus.items, OPEN_ORDER_STATUS, PENDING_ORDER_STATUS));
          this.actions.stateGo(ORDER_HISTORY_STATE);
          break;
        case Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.OPEN_CASES_COUNT:
          this.actions.setCaseStatusFilter(this.setupFilter(this.state.caseStatus.items, OPEN_CASE_STATUS, NEW_CASE_STATUS));
          this.actions.stateGo(CASES_LIST_STATE_REDIRECT, {
            customerId: this.state.currentCustomerId
          });
          break;
        case Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.EXPIRED_PI_COUNT:
          this.actions.stateGo(E_WALLET_STATE_REDIRECT, {
            customerId: this.state.currentCustomerId
          });
          break;
        case Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.PAYMENT_FAILURES_COUNT:
          this.actions.setTransactionResultFilter(this.getTransactionFilter());
          this.actions.stateGo(TRANSACTIONS_STATE);
          break;
        case Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.DISCRETIONARY_DISCOUNTS_COUNT:
          this.customerCtrl.openDiscretionaryDiscountsPopup();
          break;
        default:
          break;
      }
    }
  }, {
    key: "setupFilter",
    value: function setupFilter(items, firstValue, secondValue) {
      var filters = items.filter(function (item) {
        return item.Value === firstValue || item.Value === secondValue;
      });
      filters.forEach(function (status) {
        status.id = status.Value;
      });
      return filters;
    }
  }, {
    key: "getTransactionFilter",
    value: function getTransactionFilter() {
      var SUCCESSFUL_TRANSACTION = '0';
      var filters = this.state.transactionResults.items.filter(function (_ref) {
        var Value = _ref.Value;
        return Value !== SUCCESSFUL_TRANSACTION;
      });
      return filters;
    }
  }]);
}();
export default {
  template: require('./account.status.html'),
  require: {
    customerCtrl: '^customer'
  },
  controller: AccountStatusController,
  controllerAs: 'AccountStatus'
};